import React from 'react';
import NoModalContent from './NoModalContent';
import { LoadingDotsWrapper } from './styled';
import { Spin } from 'antd';
import '@/styles/app.css';

const LoadingModalContent = () => (
  <NoModalContent
    message={(
      <LoadingDotsWrapper>
        <Spin />
      </LoadingDotsWrapper>
    )}
  />
);

export default LoadingModalContent;